export const SET_RELOAD_POPUP = 'reloadPopup/SET_RELOAD_POPUP';
